import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

export const EditLeaveAlert = ({
  opened,
  setOpened,
  onSubmit,
}: {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  onSubmit: () => void | Promise<void>;
}) => {
  const { palette } = useCustomTheme();
  const { sm } = useScreen();

  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={() => {
        setOpened(false);
      }}
      onSubmit={onSubmit}
      Title={<Text tId={'EDIT_LEAVE_ALERT_TITLE'} />}
      MainButton={<Text tId={'LEAVE'} />}
    >
      <FlexRow gridGap={14} justifyContent="flex-start">
        <Icon size={sm ? 30 : 24} color={palette.info.main}>
          info
        </Icon>
        <Font variant={'body2'} color={'textPrimary'}>
          <Text tId={'EDIT_LEAVE_ALERT_DESCRIPTION'} />
        </Font>
      </FlexRow>
    </ActionDialog>
  );
};
